
const m = window.require("truth-helpers/helpers/lte");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
